import {
    // eslint-disable-next-line
    map, tileLayer, latLngBounds, marker, icon, divIcon,
} from 'leaflet';
import 'leaflet/dist/leaflet.css';

const mapBlocks = document.querySelectorAll('.js-listing-map-block');

const initMap = (block) => {

    let mapObj = null;

    // eslint-disable-next-line
    let bounds = latLngBounds();

    const addMarker = (listing) => {

        // eslint-disable-next-line
        let lat = parseFloat(listing.latitude),
            // eslint-disable-next-line
            lng = parseFloat(listing.longitude);

        if (!lat || !lng) {

            return;

        }

        // const m = marker([lat, lng]).addTo(mapObj);
        const markerSize = 48; // px
        const m = marker([lat, lng], {
            icon: divIcon({
                className: 'listing-map-marker',
                iconSize: [markerSize, markerSize],
                iconAnchor: {
                    x: markerSize / 2,
                    y: -8,
                },
                html: listing.mapIconSvg,
            }),
        }).addTo(mapObj);

        const image = listing.image && listing.image.url ? listing.image.url : '';
        const summary = listing.summary ? `<p class="summary">${listing.summary}</p>` : '';
        const location = listing.location ? listing.location : '';
        // eslint-disable-next-line
        const type = listing.type;
        const link = listing.link;
        const listingName = listing.link ? `<a href=${link}><strong>${listing.name}</strong></a>` : `<strong>${listing.name}</strong>`;

        let content = '';

        if (image) {

            content = `
                <div id="listings-map-infowindow" class="flex gap-half">
                    <div class="gmap-img"><a href="${link}" style="background-image: url('${image}')"> </a></div>
                    <div>
                        <p>${listingName}</p>
                        <p>${location}</p>
                        ${summary}
                    </div>
                </div>
            `;

        } else {

            content = `
                <div id="listings-map-infowindow" class="flex gap-half">
                    <div>
                        <p>${listingName}</p>
                        <p>${location}</p>
                        ${summary}
                    </div>
                </div>
            `;

        }

        m.bindPopup(content);

    };

    const renderListingsMarkers = (listings) => {

        // eslint-disable-next-line
        for (let listing of listings) {

            if (listing.latitude && listing.longitude) {

                bounds.extend([listing.latitude, listing.longitude]);

            }

            addMarker(listing);

        }

        mapObj.fitBounds(bounds, {
            padding: [50, 50],
        });

        if (listings.length === 1) {

            mapObj.setZoom(10);

        }

    };

    const mapID = block.getAttribute('id');

    const mapboxTiles = tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + block.getAttribute('data-map-box-token'), {
        attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        tileSize: 512,
        zoomOffset: -1,
        id: 'mapbox/streets-v11',
    });

    mapObj = map(mapID, {
        maxZoom: 18,
        minZoom: 6,
        zoom: 14,
        attributionControl: false,
        center: [41.88262125504959, -87.62371964253434],
    });

    mapObj.addLayer(mapboxTiles);

    mapObj.scrollWheelZoom.disable();

    // fetch listings and custom locations
    fetch('/' + block.dataset.api, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => response.json())
        .then((listings) => {

            renderListingsMarkers(listings);

        });

};

// loop through all map blocks
mapBlocks.forEach((block) => {

    initMap(block);

});
